interface ImageArray {
    "medium-large": { url: string }
}
interface SizedImage {
    sizes: {
        "medium-large": string
    }
}

const getAlgoliaImageFromArray = (images?: ImageArray | ImageArray[] | SizedImage): string | null => {
    if (images && Array.isArray(images) && images[0]) {
        const found = images[0]["medium-large"]?.url;
        if (found) {
            return found;
        }
    } else if (images && typeof images === 'object') {
        // @ts-ignore
        return images["medium-large"]?.url;
        // @ts-ignore
    } else if (images?.sizes) {
        // @ts-ignore
        return images.sizes["medium-large"];
    }
    return null;
};

export default getAlgoliaImageFromArray;
